import React from 'react';
import { toast } from 'react-toastify';
import { captureEvent } from '../../utils/posthogClient';
import { PH_CTA, PH_DIRECT, PH_PLACEMENT } from '../../utils/posthogEvents';
import {
  resolveSearch,
  SEARCH_FUSE_OPTIONS,
  withSearchAliases,
} from '../../utils/conditionSearch';
import Link from 'next/link';
import Image from 'next/image';
import {
  weightloss,
  sexualcare,
  urgentcare,
  dentalcare,
  theDoctor,
  newImage,
  trustPilotReviewNew,
  excellentNew,
  homeHero,
  refills,
  herohome1,
  herohome2,
  herohome4,
  herohome3,
} from '../../assets/images';
import {
  GreenBgTick,
  ArrowRightShort,
  WhiteArrowDiagonal,
} from '../../assets/icons';
import { Container, Row, Col } from 'react-bootstrap';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { AddSearchTerm } from '../../DB/DB';
import TrustPilot from '../trustPilot';
const HeroHomeNew = ({ allConditions }) => {
  const router = useRouter();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const handleOnSelect = async (e) => {
    await AddSearchTerm(e.title, e.objectId);
    router.push(`/services/${e.objectId}/${adjustTitle(e.title)}`);
    // router
  };
  const handleOnSearch = async (string, results) => {
    //for checking the search terms
    //console.log('IN THE HANDLE ON SEARCH', string, results?.[0]?.objectId);
    setSearchTerm(string);
    setSearchResults(results);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const match = resolveSearch(searchTerm, searchResults);
    if (!match) {
      // Nothing we treat matched. Saying so beats dropping the patient on
      // whichever condition scored least badly, which is what the old
      // unconditional searchResults[0] push did.
      if (searchTerm) {
        toast.info(
          `We don't currently treat "${searchTerm}". Try browsing our conditions below.`
        );
      }
      return;
    }
    await AddSearchTerm(searchTerm, match.objectId);
    router.push(`/services/${match.objectId}/${adjustTitle(match.title)}`);
  };

  const formatResult = (item) => {
    return (
      <>
        <span className='conditionName'>{item.title}</span>
      </>
    );
  };
  return (
    <section className='tw-w-full tw-h-auto'>
      {/* <Link href='/diagnosis?diseaseID=0IAR9Ij8yG'>
        <div className='tw-w-full tw-bg-ribbon_blue tw-text-white tw-text-center tw-py-2 tw-flex tw-items-center tw-gap-x-2 tw-justify-center tw-cursor-pointer'>
          <TheI />
          Not sure? Take the Quiz
        </div>
      </Link> */}

      <div className='tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem] tw-mx-auto tw-pt-8'>
        <Container fluid className=''>
          <Row className=' lg:tw-px-4'>
            {' '}
            <p className='tw-text-ribbon_blue tw-font-medium tw-mb-2 tw-px-0'>
              ONLINE TELEHEALTH SERVICES
            </p>
            <div className=' tw-flex tw-bg-[#F2FAF7] tw-gap-x-2 tw-py-2 tw-px-3 tw-max-w-fit tw-rounded-lg tw-items-center '>
              <div className='tw-flex-shrink-0'>
                <GreenBgTick />
              </div>

              <p className='tw-m-0 tw-text-sm lg:tw-text-base'>
                Trusted healthcare provider for 20+ years
              </p>
            </div>
          </Row>
          <Row className='p-0 tw-mt-4 tw-mb-8'>
            <Col lg={5} className='p-0 px-xl-3'>
              <div className='tw-flex tw-flex-col '>
                <h1 className='tw-font-semibold XL:tw-text-[48px] tw-leading-[1.5] tw-mb-8'>
                  Get the{' '}
                  <span className='gradientText'>
                    care you
                    <br className='tw-hidden xl:tw-block' /> need
                  </span>{' '}
                  from the
                  <br className='tw-hidden xl:tw-block' /> comfort of home.
                </h1>
                <ul className=' tw-list-none tw-p-0 tw-flex tw-flex-col tw-gap-y-6 tw-mb-8 lg:tw-mb-12 '>
                  {[
                    'No insurance needed',
                    'Talk to a licensed doctor',
                    'No copay',
                  ].map((item, index) => (
                    <li
                      key={index}
                      className='tw-flex tw-items-center tw-gap-x-2 tw-text-base lg:tw-text-xl tw-text-ribbon_blue tw-m-0'
                    >
                      <CheckMarkIcon /> <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href='#services'
                  onClick={() =>
                    captureEvent(PH_DIRECT.CLICK, {
                      cta: PH_CTA.START_TREATMENT,
                      placement: PH_PLACEMENT.HERO,
                    })
                  }
                  className='tw-block tw-no-underline hover:tw-no-underline tw-p-[0.125rem] tw-rounded-full hero-home-new-cta tw-mt-2 tw-mb-4'
                >
                  <div className=' tw-bg-black tw-text-base lg:tw-text-xl tw-h-14 lg:tw-h-[62px] tw-px-4 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-gap-x-2 tw-cursor-pointer'>
                    <span className='tw-font-medium tw-text-lg xl:tw-text-xl tw-text-white'>
                      Start treatment
                    </span>

                    <ArrowRightShort />
                  </div>
                </a>
                <div className=' tw-flex tw-justify-center tw-items-center tw-mb-8'>
                  <p className=' tw-mb-0 tw-text-[#5F5F5F] tw-text-base tw-font-medium'>
                    Starting at $39.99{' '}
                  </p>{' '}
                  <span className=' tw-px-3 tw-hidden lg:tw-flex'>
                    <Bullet />
                  </span>
                  <p className=' tw-mb-0 tw-text-[#5F5F5F] tw-text-base tw-font-medium tw-hidden lg:tw-flex'>
                    Online treatment, no waiting room
                  </p>
                </div>
                <div className='tw-px-4 lg:tw-px-12 tw-py-[0.625rem] tw-bg-[#FAF9F9] tw-rounded-2xl tw-h-full tw-flex tw-flex-col tw-justify-center'>
                  <div className='tw-flex tw-items-center tw-justify-between'>
                    <a
                      href='https://www.trustpilot.com/review/24hrdoc.com'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <div className='tw-relative tw-w-[120px] XL:tw-w-[184px] tw-h-[91px] tw-cursor-pointer'>
                        <Image
                          src={trustPilotReviewNew}
                          layout='fill'
                          objectFit='contain'
                          alt='trust-pilot!'
                        />
                      </div>
                    </a>
                    <a
                      href='https://www.trustpilot.com/review/24hrdoc.com'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <div className='tw-relative tw-w-[120px] XL:tw-w-[184px] tw-h-[91px] tw-cursor-pointer'>
                        <Image
                          src={excellentNew}
                          layout='fill'
                          objectFit='contain'
                          alt='trust-pilot!'
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </Col>
            {/* <Col
              lg={7}
              className='px-0 px-lg-3 tw-hidden lg:tw-flex lg:tw-justify-end'
            >
              <div className=' tw-relative tw-flex tw-justify-end'>
                <Image
                  src={homeHero}
                  alt='24hrdoc services'
                  width={633}
                  height={657}
                  className='tw-rounded-2xl'
                  quality={100}
                />
                
              </div>
            </Col> */}
            <Col
              lg={{ span: 6, offset: 1 }}
              className='px-0  tw-hidden lg:tw-flex lg:tw-justify-end'
            >
              <div className=' tw-relative tw-w-full lg:tw-min-h-[643px]'>
                <Image
                  src={homeHero}
                  alt='24hrdoc services'
                  // width={633}
                  //height={657}
                  layout='fill'
                  className='tw-rounded-2xl tw-object-cover'
                  quality={100}
                  priority
                />
                {/* <TrustPilot /> */}
              </div>
            </Col>
          </Row>
          <form onSubmit={handleSubmit} className=' tw-hidden lg:tw-block'>
            <div className='heroSearch tw-mb-4 tw-relative'>
              <button
                type='submit'
                aria-label='Search conditions'
                className='searchIconContainer'
              >
                <SearchIcon />
              </button>
              <ReactSearchAutocomplete
                items={withSearchAliases(allConditions)}
                onSearch={handleOnSearch}
                onSelect={handleOnSelect}
                resultStringKeyName='title'
                fuseOptions={SEARCH_FUSE_OPTIONS}
                formatResult={formatResult}
                placeholder='Search Condition'
                maxResults={5}
                className='diseaseSearchBarHome tw-mb-6'
              />
            </div>
          </form>
          <div className=' tw-mb-8 tw-hidden lg:tw-flex'>
            <span className=' tw-font-[500] tw-text-xl'>
              Know what you need?{' '}
            </span>{' '}
            &nbsp;
            <span className=' tw-text-lg tw-text-[#5F5F5F]'>
              search by condition
            </span>
          </div>
          <Row className='g-4 px-0 tw-hidden lg:tw-flex'>
            <Col md={3}>
              <div className='tw-group tw-relative tw-h-[200px] tw-rounded-2xl tw-overflow-hidden'>
                <div className='tw-relative tw-w-full tw-h-full tw-z-10 tw-p-3 tw-text-white tw-flex tw-flex-col tw-gap-y-4'>
                  <Link href='/sexual-diseases'>
                    <div className='tw-self-end tw-justify-self-start tw-cursor-pointer cta-arrows'>
                      <WhiteArrowDiagonal />
                    </div>
                  </Link>

                  <Link href='/sexual-diseases'>
                    <div className='tw-mt-auto tw-flex tw-flex-col tw-gap-y-4 tw-cursor-pointer'>
                      <h3 className='tw-m-0'>Sexual Care</h3>
                      <p className='tw-leading-5 tw-m-0'>
                        Confidential Care for your
                        <br className='lg:tw-hidden xl:tw-block' /> sexual
                        wellness.
                      </p>
                    </div>
                  </Link>
                </div>
                <div
                  className='tw-absolute tw-inset-0 tw-z-[1] tw-rounded-2xl'
                  style={{ background: 'rgba(30,30,30,0.35)' }}
                />
                <Image
                  src={herohome1}
                  layout='fill'
                  objectFit='cover'
                  alt='sexualcare'
                  className='tw-transition-transform tw-duration-500 group-hover:tw-scale-110'
                />
              </div>
            </Col>{' '}
            <Col md={3}>
              <div className='tw-relative tw-h-[200px] tw-rounded-2xl'>
                <div className='tw-relative tw-w-full tw-h-full tw-z-10 tw-p-3 tw-text-white tw-flex tw-flex-col  tw-gap-y-4'>
                  <Link href='/urgent-care/dental-infection'>
                    <div className='tw-self-end tw-justify-self-start tw-cursor-pointer cta-arrows'>
                      <WhiteArrowDiagonal />
                    </div>
                  </Link>
                  <Link href='/urgent-care/dental-infection'>
                    <div className='tw-mt-auto tw-flex tw-flex-col tw-gap-y-4 tw-cursor-pointer'>
                      <h3 className='tw-m-0'>Dental Care</h3>
                      <p className='tw-leading-5 tw-m-0'>
                        We provide care for
                        <br className='lg:tw-hidden xl:tw-block' /> Dental
                        infections
                      </p>
                    </div>
                  </Link>
                </div>{' '}
                <div
                  className='tw-absolute tw-inset-0 tw-z-[1] tw-rounded-2xl'
                  style={{ background: 'rgba(30,30,30,0.35)' }}
                />
                <Image
                  src={herohome2}
                  layout='fill'
                  objectFit='cover'
                  alt='dentalcare'
                  className='tw-rounded-2xl'
                />
              </div>
            </Col>
            <Col md={3}>
              <div className='tw-relative  tw-h-[200px]'>
                <div className='tw-relative tw-w-full tw-h-full tw-z-10 tw-p-3 tw-text-white tw-flex tw-flex-col   t'>
                  <Link href='/prescription-refill'>
                    <div className='tw-self-end tw-justify-self-start tw-cursor-pointer cta-arrows'>
                      <WhiteArrowDiagonal />
                    </div>
                  </Link>

                  <Link href='/prescription-refill'>
                    <div className='tw-mt-auto tw-flex tw-flex-col tw-gap-y-4 tw-cursor-pointer'>
                      <h3 className='tw-m-0 '>Refills</h3>
                      <p className='tw-leading-5 tw-m-0'>
                        Get your prescription refills without the hassle of
                        in-person visits.
                        <br className='lg:tw-hidden xl:tw-block' /> starts here.
                      </p>
                    </div>
                  </Link>
                </div>
                <div
                  className='tw-absolute tw-inset-0 tw-z-[1] tw-rounded-2xl'
                  style={{ background: 'rgba(30,30,30,0.35)' }}
                />
                <Image
                  src={herohome3}
                  layout='fill'
                  objectFit='cover'
                  alt='prescription refills'
                  className='tw-rounded-2xl'
                />
              </div>
            </Col>
            <Col md={3}>
              <div className='tw-group tw-relative tw-h-[200px] tw-rounded-2xl tw-overflow-hidden'>
                <div className='tw-relative tw-w-full tw-h-full tw-z-10 tw-p-3 tw-text-white tw-flex tw-flex-col  tw-gap-y-4'>
                  <Link href='/urgent-care/urgent-medical-care'>
                    <div className='tw-self-end tw-justify-self-start tw-cursor-pointer cta-arrows'>
                      <WhiteArrowDiagonal />
                    </div>
                  </Link>

                  <Link href='/urgent-care/urgent-medical-care'>
                    <div className='tw-mt-auto tw-flex tw-flex-col tw-gap-y-4 tw-cursor-pointer'>
                      <h3 className='tw-m-0'>Urgent Care</h3>
                      <p className='tw-leading-5 tw-m-0'>
                        Fast, reliable care when you
                        <br className='lg:tw-hidden xl:tw-block' /> need it
                        most.
                      </p>
                    </div>
                  </Link>
                </div>
                <div
                  className='tw-absolute tw-inset-0 tw-z-[1] tw-rounded-2xl'
                  style={{ background: 'rgba(30,30,30,0.35)' }}
                />
                <Image
                  src={herohome4}
                  layout='fill'
                  objectFit='cover'
                  alt='urgentcare'
                  className='tw-transition-transform tw-duration-500 group-hover:tw-scale-110'
                />
              </div>
            </Col>{' '}
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default HeroHomeNew;
function adjustTitle(str) {
  return str
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w-]/g, ''); // Remove special characters (optional)
}
const CheckMarkIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.3151 21.9311 10.6462 21.8 10'
      stroke='#195D9D'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M8 12.5C8 12.5 9.5 12.5 11.5 16C11.5 16 17.0588 6.83333 22 5'
      stroke='#195D9D'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const Bullet = () => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='5' cy='5' r='5' fill='#D9D9D9' />
  </svg>
);
const SearchIcon = () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='24' height='24' rx='16' fill='#1E1E1E' />
    <path
      d='M22.9936 22.9938L19.6134 19.6135M21.4395 15.223C21.4395 18.6563 18.6562 21.4396 15.2229 21.4396C11.7895 21.4396 9.00623 18.6563 9.00623 15.223C9.00623 11.7896 11.7895 9.00635 15.2229 9.00635C18.6562 9.00635 21.4395 11.7896 21.4395 15.223Z'
      stroke='white'
      strokeWidth='1.14183'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
